import BoardCard from './board-card';
import IconButton from '../../../common/components/icon-button/icon-button';
import SortAscendingIcon from '../../../common/icons/sort-ascending';
import SortDescendingIcon from '../../../common/icons/sort-descending';
import { nameOf } from '../../../global/contexts/catalogs/catalogs';
import { PENDING_FILTERS } from '../utils/board';

import '../styles/board-column.css';

function OrderToggle({ title, value, onChange }) {
    const isAscending = value === 'asc';
    return (
        <IconButton
            className="icon-button--small"
            icon={isAscending ? <SortAscendingIcon size={18} /> : <SortDescendingIcon size={18} />}
            label={`${title}: orden por ID ${isAscending ? 'ascendente' : 'descendente'}. Cambiar a ${isAscending ? 'descendente' : 'ascendente'}`}
            onClick={() => onChange(isAscending ? 'desc' : 'asc')}
        />
    );
}

export default function BoardColumn({
    column,
    tasks,
    shown,
    isExact,
    total,
    loaded,
    hidden,
    order,
    pending,
    pendingCounts,
    isLoading,
    tiers,
    repositories,
    onOrderChange,
    onPendingChange,
    onShowFindings,
}) {
    const isPending = column.key === 'pending';

    return (
        <div className="board-column">
            <header className="board-column__header">
                <h2 className="board-column__title">{column.title}</h2>
                <span
                    className="board-column__count"
                    title={isExact ? undefined : 'Puede incluir hallazgos fuera de las tarjetas cargadas'}
                >
                    {shown}{isExact ? '' : '*'}
                </span>
                <OrderToggle title={column.title} value={order} onChange={onOrderChange} />
            </header>

            {isPending && (
                <div className="board-column__filter" role="group" aria-label="Filtrar pendientes">
                    {PENDING_FILTERS.map((item) => (
                        <button
                            key={item.key || 'todas'}
                            type="button"
                            aria-pressed={pending.key === item.key}
                            className={`board-column__filter-option${pending.key === item.key ? ' board-column__filter-option--on' : ''}`}
                            onClick={() => onPendingChange(item.key)}
                        >
                            {item.label}
                            {item.states.length === 1 && <span className="board-column__filter-count">{pendingCounts[item.states[0]]}</span>}
                        </button>
                    ))}
                </div>
            )}

            {isLoading && <p className="board-column__empty">Cargando…</p>}
            {!isLoading && tasks.length === 0 && <p className="board-column__empty">Nada aquí.</p>}

            {tasks.length > 0 && (
                <ul className="board-column__cards">
                    {tasks.map((task) => (
                        <BoardCard
                            key={task.id}
                            task={task}
                            tierName={task.tierId ? nameOf(tiers, task.tierId, 'Tier') : null}
                            repository={repositories?.get(task.repositoryId)}
                        />
                    ))}
                </ul>
            )}

            {total > loaded && (
                <p className="board-column__note">Se muestran {loaded} de {total}. Actualiza para consultar los cambios recientes.</p>
            )}
            {hidden > 0 && (
                <button type="button" className="board-column__hidden" onClick={onShowFindings}>
                    {hidden} {hidden === 1 ? 'hallazgo oculto' : 'hallazgos ocultos'} · mostrar
                </button>
            )}
        </div>
    );
}
